import {
  CaesarsButton,
  openURL,
  useIsMD,
} from '@eCommerce/frontend-legacy-shared-library';
import {Link, Text, View} from 'native-base';
import React from 'react';

export interface FooterProps {
  CTALabel: string;
  onPress: () => void;
  buttonDisabled?: boolean;
  testID: string;
}

const PRFooter: React.FC<FooterProps> = (props) => {
  const {CTALabel, onPress, buttonDisabled = false, testID} = props;
  const isMD = useIsMD();
  return (
    <View
      alignItems="center"
      pt={isMD ? 4 : undefined}
      pb={isMD ? undefined : '20px'}
      width="100%"
      maxW="390px"
      justifyContent="center"
      testID={testID + '-footer'}
    >
      <CaesarsButton
        title={CTALabel}
        onPress={onPress}
        isFullWidth
        isDisabled={buttonDisabled}
        testID={testID + '-button'}
      />
      <Text
        mt={5}
        fontFamily="heading"
        fontWeight="400"
        fontSize={3}
        lineHeight="20px"
      >
        {`Don't`} have an account?{' '}
        <Link
          fontWeight="500"
          color="caesarRewards"
          isUnderlined={false}
          testID={testID + '-sign-up-link'}
          onPress={() => openURL('/a/security/register.aspx')}
          href="/a/security/register.aspx"
          _web={{
            style: {cursor: 'pointer'} as any,
          }}
          accessible={true}
          accessibilityLabel="Sign up"
          accessibilityRole="link"
          accessibilityHint="Create a new Caesars Reward account"
        >
          Sign Up
        </Link>
      </Text>
    </View>
  );
};

export default PRFooter;
